import React from "react";
import { Bar, XAxis, YAxis, BarChart, LabelList, ResponsiveContainer, Legend, Tooltip } from "recharts";

// x={props.type === 'GT' ? x + 100 : x + 70}
const CustomizedLabel = (props) => {
  const { x, y, value } = props;
  if (value) {
    return (
      <g>
        <text
          x={(x + props.width / 2)}
          y={y}
          dy={17}
          fill={props.fill}
          fontSize={12}
          textAnchor="middle"
          position="center"
        >
          {value?.toFixed(0) === 0 ? '':value?.toFixed(0)+'%'}
        </text>
      </g>
    );
  } else {
    return ''
  }
};

const calculateValue = (value) => {
  let arr=[];
  if(value){
    value.forEach((item) => {
      let obj = {};
      obj['Division'] = Object.entries(item)[Object.entries(item).length-1][1]
      Object.entries(item).forEach((elm,ind) => {
        if( ind < (Object.entries(item).length - 1)){
          obj['GT'+(ind+1)]= elm[1].GT;
          obj['MT'+(ind+1)]= elm[1].MT;
          obj['NA'+(ind+1)]= elm[1]['National Accounts'];
          obj['RTM'+(ind+1)]= elm[1].RTM;
          obj['EC'+(ind+1)]= elm[1].eCommerce;
          obj['year'+(ind+1)]= elm[0]
        }
      })
      arr.push(obj)
    })
  }
  // let arr = []
  // if (value) {
  //   value.forEach((item) => {
  //     arr.push({
  //       Division: item.Division,
  //       GT1: item[2016]?.GT, MT1: item[2016]?.MT, NA1:item[2016]?.['National Accounts'], RTM1:item[2016]?.RTM, EC1:item[2016]?.eCommerce,
  //       GT2: item[2017]?.GT, MT2: item[2017]?.MT, NA2:item[2017]?.['National Accounts'], RTM2:item[2017]?.RTM, EC2:item[2017]?.eCommerce,
  //       GT3: item[2018]?.GT, MT3: item[2018]?.MT, NA3:item[2018]?.['National Accounts'], RTM3:item[2018]?.RTM, EC3:item[2018]?.eCommerce,
  //       GT4: item[2019]?.GT, MT4: item[2019]?.MT, NA4:item[2019]?.['National Accounts'], RTM4:item[2019]?.RTM, EC4:item[2019]?.eCommerce,
  //       GT5: item[2020]?.GT, MT5: item[2020]?.MT, NA5:item[2020]?.['National Accounts'], RTM5:item[2020]?.RTM, EC5:item[2020]?.eCommerce,
  //       year1: '2016', year2: '2017', year3: '2018', year4: '2019', year5: '2020'
  //     })
  //   })
  // }
  // console.log(arr)
  return arr

}

const renderLegend = (props) => {

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#264653', marginRight: '8px' }}></span>
        <span>GT</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#2A9D8F', marginRight: '8px' }}></span>
        <span>MT</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#e9c46a', marginRight: '8px' }}></span>
        <span>National Accounts</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', marginRight: '16px', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#f4a261', marginRight: '8px' }}></span>
        <span>RTM</span>
      </span>
      <span style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '600' }}>
        <span style={{ width: '8px', height: '8px', backgroundColor: '#e76f51', marginRight: '8px' }}></span>
        <span>eCommerce</span>
      </span>

    </div>

  );
}

const renderTooltip = e => {
  if(e.label && e.payload){
    return (
      <div className="major-channel-utilization-tooltip">
      <div className="major-channel-utilization-tooltip-heading">
        <span>{e.label}</span>
      </div>
      <div className="major-channel-utilization-tooltip-data">
        {
          e.payload.map((item,ind)=>(
            <span key={item.name+ind} style={{ color: item.color }}>
              {getName(item.name)} : {item.value?.toFixed(0)}%
            </span>
          ))
        }
      </div>
    </div>
    );
  }else{
    return '';
  }
};

const getName = (value)=>{
  if(value){
    let subValue = value.substr(0, 2)
    return subValue === 'NA' ? 'National Accounts' : subValue === 'RT' ? 'RTM' : subValue === 'EC' ? 'eCommerce' : subValue
  }
  else{
    return '';
  }
};

function GTMTBarChart(props) {
  let graphData = calculateValue(props.data)    // value conversion for graph mapping
  return (
    <>
      <ResponsiveContainer width={'100%'} height={'100%'}>
        <BarChart
          width={250}
          height={150}
          data={graphData}
          layout="vertical"
        >
          <XAxis type="number" hide style={{ fontSize: '12px' }} padding={{ right: 5 }} />
          <YAxis dataKey="Division" style={{ fontSize: '12px' }} type="category" tickLine={false} />
          <Tooltip content={e => renderTooltip(e)} />
          <Legend content={renderLegend} />
          {graphData[0]?.GT1 ? <Bar
            dataKey="GT1"
            fill={'#264653'}
            barSize={25}
            stackId='a'
          >
            <LabelList dataKey='GT1' content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='GT' />
          </Bar> : null}

          {graphData[0]?.MT1 ? <Bar
            dataKey="MT1"
            fill={'#2A9D8F'}
            barSize={25}
            stackId='a'
          >
            <LabelList dataKey="MT1" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='MT' />
          </Bar> : null}

          {graphData[0]?.NA1 ? <Bar
            dataKey="NA1"
            fill={'#e9c46a'}
            barSize={25}
            stackId='a'
          >
            <LabelList dataKey='NA1' content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='National Accounts' />
          </Bar> : null}

          {graphData[0]?.RTM1 ? <Bar
            dataKey="RTM1"
            fill={'#f4a261'}
            barSize={25}
            stackId='a'
          >
            <LabelList dataKey="RTM1" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='RTM' />
          </Bar> : null}

          {graphData[0]?.EC1 ? <Bar
            dataKey="EC1"
            fill={'#e76f51'}
            barSize={25}
            stackId='a'
          >
            <LabelList dataKey='EC1' content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='eCommerce' />
            <LabelList dataKey="year1" fontSize={12} position="right" fill={'black'} />          
          </Bar> : null}

          {graphData[0]?.GT2 ? <Bar
            dataKey="GT2"
            fill={'#264653'}
            barSize={25}
            stackId='b'
          >
            <LabelList dataKey="GT2" content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='GT' />
          </Bar> : null}

          {graphData[0]?.MT2 ? <Bar
            dataKey="MT2"
            fill={'#2A9D8F'}
            barSize={25}
            stackId='b'
          >
            <LabelList dataKey="MT2" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='MT' />
          </Bar> : null}

          {graphData[0]?.NA2 ? <Bar
            dataKey="NA2"
            fill={'#e9c46a'}
            barSize={25}
            stackId='b'
          >
            <LabelList dataKey='NA2' content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='National Accounts' />
          </Bar> : null}

          {graphData[0]?.RTM2 ? <Bar
            dataKey="RTM2"
            fill={'#f4a261'}
            barSize={25}
            stackId='b'
          >
            <LabelList dataKey="RTM2" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='RTM' />
          </Bar> : null}

          {graphData[0]?.EC2 ? <Bar
            dataKey="EC2"
            fill={'#e76f51'}
            barSize={25}
            stackId='b'
          >
            <LabelList dataKey='EC2' content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='eCommerce' />
            <LabelList dataKey="year2" fontSize={12} position="right" fill={'black'} />          
          </Bar> : null}

          {graphData[0]?.GT3 ? <Bar
            dataKey="GT3"
            fill={'#264653'}
            barSize={25}
            stackId='c'
          >
            <LabelList dataKey="GT3" content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='GT' />
          </Bar> : null}

          {graphData[0]?.MT3 ? <Bar
            dataKey="MT3"
            fill={'#2A9D8F'}
            barSize={25}
            stackId='c'
          >
            <LabelList dataKey="MT3" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='MT' />
          </Bar> : null}

          {graphData[0]?.NA3 ? <Bar
            dataKey="NA3"
            fill={'#e9c46a'}
            barSize={25}
            stackId='c'
          >
            <LabelList dataKey='NA3' content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='National Accounts' />
          </Bar> : null}

          {graphData[0]?.RTM3 ? <Bar
            dataKey="RTM3"
            fill={'#f4a261'}
            barSize={25}
            stackId='c'
          >
            <LabelList dataKey="RTM3" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='RTM' />
          </Bar> : null}

          {graphData[0]?.EC3 ? <Bar
            dataKey="EC3"
            fill={'#e76f51'}
            barSize={25}
            stackId='c'
          >
            <LabelList dataKey='EC3' content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='eCommerce' />
            <LabelList dataKey="year3" fontSize={12} position="right" fill={'black'} />          
          </Bar> : null}

          {graphData[0]?.GT4 ? <Bar
            dataKey="GT4"
            fill={'#264653'}
            barSize={25}
            stackId='d'
          >
            <LabelList dataKey="GT4" content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='GT' />
          </Bar> : null}

          {graphData[0]?.MT4 ? <Bar
            dataKey="MT4"
            fill={'#2A9D8F'}
            barSize={25}
            stackId='d'
          >
            <LabelList dataKey="MT4" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='MT' />
          </Bar> : null}

          {graphData[0]?.NA4 ? <Bar
            dataKey="NA4"
            fill={'#e9c46a'}
            barSize={25}
            stackId='d'
          >
            <LabelList dataKey='NA4' content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='National Accounts' />
          </Bar> : null}

          {graphData[0]?.RTM4 ? <Bar
            dataKey="RTM4"
            fill={'#f4a261'}
            barSize={25}
            stackId='d'
          >
            <LabelList dataKey="RTM4" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='RTM' />
          </Bar> : null}

          {graphData[0]?.EC4 ? <Bar
            dataKey="EC4"
            fill={'#e76f51'}
            barSize={25}
            stackId='d'
          >
            <LabelList dataKey='EC4' content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='eCommerce' />
            <LabelList dataKey="year4" fontSize={12} position="right" fill={'black'} />          
          </Bar> : null}

          {graphData[0]?.GT5 ? <Bar
            dataKey="GT5"
            fill={'#264653'}
            barSize={25}
            stackId='e'
          >
            <LabelList dataKey="GT5" content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='GT' />
          </Bar> : null}

          {graphData[0]?.MT5 ? <Bar
            dataKey="MT5"
            fill={'#2A9D8F'}
            barSize={25}
            stackId='e'
            label='MT5'
          >
            <LabelList dataKey="MT5" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='MT' />
          </Bar> : null}

          {graphData[0]?.NA5 ? <Bar
            dataKey="NA5"
            fill={'#e9c46a'}
            barSize={25}
            stackId='e'
          >
            <LabelList dataKey='NA5' content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='National Accounts' />
          </Bar> : null}

          {graphData[0]?.RTM5 ? <Bar
            dataKey="RTM5"
            fill={'#f4a261'}
            barSize={25}
            stackId='e'
          >
            <LabelList dataKey="RTM5" content={CustomizedLabel} fontSize={12} position="top" fill={'black'} type='RTM' />
          </Bar> : null}

          {graphData[0]?.EC5 ? <Bar
            dataKey="EC5"
            fill={'#e76f51'}
            barSize={25}
            stackId='e'
          >
            <LabelList dataKey='EC5' content={CustomizedLabel} fontSize={12} position="top" fill={'white'} type='eCommerce' />
            <LabelList dataKey="year5" fontSize={12} position="right" fill={'black'} />          
          </Bar> : null}

        </BarChart>
      </ResponsiveContainer>
    </>
  );
}

export default GTMTBarChart;
